// extracted by mini-css-extract-plugin
module.exports = {"aboutUs":"about-us_aboutUs__7PU0p","text-color":"about-us_text-color__324Jj"};